var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoreHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 17.0885C25.255 17.0885 25.8333 16.5102 25.8333 15.7968C25.8333 15.0834 25.255 14.5051 24.5417 14.5051C23.8283 14.5051 23.25 15.0834 23.25 15.7968C23.25 16.5102 23.8283 17.0885 24.5417 17.0885Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4997 17.0885C16.213 17.0885 16.7913 16.5102 16.7913 15.7968C16.7913 15.0834 16.213 14.5051 15.4997 14.5051C14.7863 14.5051 14.208 15.0834 14.208 15.7968C14.208 16.5102 14.7863 17.0885 15.4997 17.0885Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45866 17.0885C7.17203 17.0885 7.75033 16.5102 7.75033 15.7968C7.75033 15.0834 7.17203 14.5051 6.45866 14.5051C5.74529 14.5051 5.16699 15.0834 5.16699 15.7968C5.16699 16.5102 5.74529 17.0885 6.45866 17.0885Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreHorizontal);
export default __webpack_public_path__ + "static/media/icon-more-horizontal.b468d82fe0689ce51d163371e9634544.svg";
export { ForwardRef as ReactComponent };